import PermissionIssue from "../../components/permissionIssue";
import { useEffect, useState } from "react";
import { useAppSelector } from "../../store/store";
import { LinearProgress } from "@mui/material";
import MainViewComponent from "../../components/mainViewComponent";

const FacilityMainViewPage = () => {
  const [isAllow, setIsAllow] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const { userData } = useAppSelector((state) => state.authReducer);

  useEffect(() => {
    if (userData) {
      const permissions = userData.permission ? JSON.parse(userData.permission) : [];
      setIsAllow(permissions.includes("29"));
      setIsReady(true);
    }
  }, [userData]);

  return isReady ? (
    <>
      {isAllow || userData.group === "admin" ? (
        <MainViewComponent />
      ) : (
        <PermissionIssue />
      )}
    </>
  ) : (
    <LinearProgress color="secondary" />
  );
};

export default FacilityMainViewPage;
